var map = {
	"../pages/ajustes/ajustes.module": [
		331,
		2
	],
	"../pages/parte-detalle/parte-detalle.module": [
		334,
		3
	],
	"../pages/partes/partes.module": [
		332,
		1
	],
	"../pages/personal/personal.module": [
		333,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 164;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 164
// module chunks = 4